export default {
    pelvicUltrasoundExamination                 : 'Pelvic Ultrasound Examination',
    indication                                  :   "indication",
    examinationMethod                           :   "examinationMethod",
    examinationView                             :   "examinationView",
    uterusPosition                            	:   "uterusPosition",
    uterusSize                            		:   "uterusSize ",
    uterusAdenomyosisTest                       :   "uterusAdenomyosisTest",
    endometriumTest                       		:   "endometriumTest",
    endometriumType                       		:   "endometriumType",
    endometriumIsoTest                       	:   "endometriumIsoTest",
    endometriumMeasuredCM					    :   "endometriumMeasuredCM",
    endometriumMeasuredMM						:   "endometriumMeasuredMM",
    endometriumMeasuredDay						:   "endometriumMeasuredDay",
    fibroType                       			:   "fibroType",
    polypType                       			:   "polypType",
    threeDCoronal								:   "threeDCoronal",
    rightOvaryMM1								:	"rightOvaryMM1",
    rightOvaryMM2								:	"rightOvaryMM2",
    rightOvaryContain							:	"rightOvaryContain",
    rightEndometriomaType						:	"rightEndometriomaType",
    rightOvarianAdhesionType					:	"rightOvarianAdhesionType",
    leftOvaryMM1								:	"leftOvaryMM1",
    leftOvaryMM2								:	"leftOvaryMM2",
    leftOvaryContain							:	"leftOvaryContain",
    leftOvarianAdhesionType						:	"leftOvarianAdhesionType",
    leftEndometriomaType						:	"leftEndometriomaType",
    dopplerStudyType							:	"dopplerStudyType",
    commentType									:	"commentType",
    impressionLocation                          :   "impressionLocation",
}